/**
 * useDebouncedValue - the settled value of something that changes fast.
 *
 * Filtering runs over lists of a few hundred items, so the input stays
 * instant (it is normal controlled state) while the FILTER only recomputes
 * once typing pauses. Debouncing the input itself would make the field feel
 * laggy, which is the usual mistake.
 */

import { useEffect, useState } from 'react';

export function useDebouncedValue<T>(value: T, delayMs = 150): T {
  const [settled, setSettled] = useState(value);

  useEffect(() => {
    // An empty query settles at once: clearing the box should restore the
    // full list immediately rather than after a pause.
    if (typeof value === 'string' && value === '') {
      setSettled(value);
      return;
    }
    const id = setTimeout(() => setSettled(value), delayMs);
    return () => clearTimeout(id);
  }, [value, delayMs]);

  return settled;
}

export default useDebouncedValue;
